import React from 'react';

import DetailsHeader from './howWeDoPartials/DetailsHeader';
import DetailsItems from './howWeDoPartials/DetailsItems';

const HowWeDoDetails = () => {
  return (
    <div className="container">
      <div className="section-oks">
        <div className="row">
          <DetailsHeader />
          <DetailsItems />
        </div>
      </div>
    </div>
  );
};

export default HowWeDoDetails;
